import { apiSlice } from './apiSlice';

export const customersApi = apiSlice.injectEndpoints({
   // Adjust baseUrl based on your actual api routing
  endpoints: (builder) => ({
    getCustomers: builder.query<any, Record<string, any> | void>({
      query: (params) => ({
        url: '/api/customers',
        params: params || undefined,
      }),
      providesTags: ['Customer'],
    }),
    getCustomerById: builder.query<any, string | number>({
      query: (id) => ({ url: `/api/customers/${id}` }),
      providesTags: (result, error, id) => [{ type: 'Customer', id }],
    }),
    createCustomer: builder.mutation<any, Record<string, any>>({
      query: (data) => ({
        url: '/api/customers',
        method: 'POST',
        data: data,
      }),
      invalidatesTags: ['Customer'],
    }),
    updateCustomer: builder.mutation<any, { id: string | number; data: Record<string, any> }>({
      query: ({ id, data }) => ({
        url: `/api/customers/${id}`,
        method: 'PUT',
        data: data,
      }),
      // Invalidate the list tag AND the per-id tag: the bare 'Customer' tag
      // (id 'LIST') does not match { type: 'Customer', id }, so without both
      // the lists would keep showing stale rows after an update.
      invalidatesTags: (result, error, { id }) => ['Customer', { type: 'Customer', id }],
    }),
    deleteCustomer: builder.mutation<void, string | number>({
      query: (id) => ({
        url: `/api/customers/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Customer'],
    }),
    toggleCustomerAccount: builder.mutation<any, string | number>({
      query: (id) => ({
        url: `/api/customers/${id}/update-has-account`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, id) => ['Customer', { type: 'Customer', id }],
    }),
    getCustomersWithoutPaginate: builder.query<any, void>({
      query: () => ({ url: '/api/Get_Customers_Without_Paginate' }),
      providesTags: ['Customer'],
    }),
    getCustomersWithoutEcommerce: builder.query<any, Record<string, any> | void>({
      query: (params) => ({
        url: '/api/customers_without_ecommerce',
        params: params || undefined,
      }),
      providesTags: ['Customer'],
    }),
    registerEcommerceAccount: builder.mutation<any, Record<string, any>>({
      query: (data) => ({
        url: '/api/customers_without_ecommerce',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Customer'],
    }),
    getCustomerPayments: builder.query<any, { id: string | number; params?: Record<string, any> }>({
      query: ({ id, params }) => ({
        // Backend route: GET customer_payments/{id}
        url: `/api/customer_payments/${id}`,
        params: params || {},
      }),
      providesTags: (result, error, { id }) => [{ type: 'Customer', id }],
    }),
    importCustomers: builder.mutation<any, FormData>({
      query: (data) => ({
        url: '/api/customers/import/csv',
        method: 'POST',
        // The axios base query forwards `data` — `body` was silently dropped.
        data,
      }),
      invalidatesTags: ['Customer'],
    }),
    checkCreditEligibility: builder.mutation<any, { customer_id: string | number; amount: number | string }>({
      query: (data) => ({
        // Backend route: POST customers/check-credit-eligibility
        url: '/api/customers/check-credit-eligibility',
        method: 'POST',
        data,
      }),
    }),
  }),
});

export const {
  useGetCustomersQuery,
  useLazyGetCustomersQuery,
  useGetCustomerByIdQuery,
  useCreateCustomerMutation,
  useUpdateCustomerMutation,
  useDeleteCustomerMutation,
  useToggleCustomerAccountMutation,
  useGetCustomersWithoutPaginateQuery,
  useGetCustomersWithoutEcommerceQuery,
  useRegisterEcommerceAccountMutation,
  useGetCustomerPaymentsQuery,
  useLazyGetCustomerPaymentsQuery,
  useImportCustomersMutation,
  useCheckCreditEligibilityMutation,
} = customersApi;


